import React, { Component } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import AppStore from '../../store/AppStore'
import SignInAction from '../actions/SignInAction'
import ToastrAction from '../../home/actions/ToastrAction'
import { PATH_FIND_EMAIL } from '../../home/constants/HomeConstants'
import { push } from 'react-router-redux'

class SignIn extends Component {
	onSubmit = (event) => {
		event.preventDefault()
		const pwd = this.refs.password.value
		const login = this.refs.login.value
		if (!pwd) {
			AppStore.dispatch(ToastrAction.error(i18n.error.password))
		}
		if (!login) {
			AppStore.dispatch(ToastrAction.error(i18n.error.login))
		}
		if (pwd && login) {
			AppStore.dispatch(SignInAction.login(login, pwd, this.props.actions))
		}
	}

	goFindEmail = () => {
		AppStore.dispatch(push(PATH_FIND_EMAIL))
	}
	
	render() {
		return (
			<div className='no-margin radius10'>
				<div className='card-content no-padding row no-margin cardLogin'>
					<form onSubmit={ this.onSubmit }>
						<div className='row no-margin'>
							<div className='col l12 m10 s10 padding-top-20'>
								<label htmlFor='login' className='valign-wrapper black-text'>
									<i className='material-icons'>person</i>
									{ i18n.login }
								</label>
							</div>
							<div className='col l12 m10 s10'>
								<input ref='login' id='login' type='text' className='validate'/>
							</div>
							<div className='col l12 m10 s10 padding-top-20'>
								<label htmlFor='password' className='valign-wrapper black-text'>
									<i className='material-icons'>lock_outline</i>
									{ i18n.password }
								</label>
							</div>
							<div className='col l12 m10 s10'>
								<input ref='password' id='password' type='password' className='validate'/>
							</div>
							<div className='col l12 m10 s10 offset-m1 offset-s1 padding-top-20'>
								<button to='dashboard'
										className='waves-effect col l12 m12 s12 waves-light btn'>{ i18n.signin }</button>
							</div>
							<div className='col l12 m10 s10 offset-m1 offset-s1 center margin-top-10'>
								<a href='https://www.aquasys.fr/aquadb/#aquadb-form'
								   target='_blank'><span>{ i18n.notYetRegistered }</span></a>
							</div>
							<div className='col l12 m10 s10 offset-m1 offset-s1 center margin-top-10'>
							<a onClick={ () => this.goFindEmail() }>
							    <span>Mot de passe oublié ?</span></a>
						</div>
						</div>
					</form>
					<div className='row'>
						<div className='col s12 center-align'>
							<a href='http://www.aquasys.fr' target='_blank'>
								<img src='https://www.aquasys.fr/wp-content/uploads/2017/10/AQUASYS-512-PX.jpg'
									 alt='logo Aquasys' width='70px' className='z-depth-1'/>
							</a>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

SignIn.propTypes = {
	actions: PropTypes.func
}
export default SignIn



// WEBPACK FOOTER //
// ./src/login/components/SignIn.js